import { createSlice } from "@reduxjs/toolkit";

export type DynamicPropertiesLoadingState = {
    isLoading: boolean;
};

const initialState: DynamicPropertiesLoadingState = {
    isLoading: false,
};

export const dynamicPropertiesLoadingState = createSlice({
    name: "DynamicPropertiesLoadingSlice",
    initialState,
    reducers: {
        setIsDynamicPropertiesLoading(state, action) {
            // isLoading: Boolean(action.payload),
            return { ...state, isLoading: Boolean(action.payload) };
        },
    },
});

export const { setIsDynamicPropertiesLoading } = dynamicPropertiesLoadingState.actions;
